import { render, staticRenderFns } from "./SpectMiocardicaEdit.vue?vue&type=template&id=6ec80740&scoped=true"
import script from "./SpectMiocardicaEdit.vue?vue&type=script&lang=js"
export * from "./SpectMiocardicaEdit.vue?vue&type=script&lang=js"
import style0 from "./SpectMiocardicaEdit.vue?vue&type=style&index=0&id=6ec80740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec80740",
  null
  
)

export default component.exports